import React from 'react';
import PropTypes from 'prop-types';
import PlanMobile from '../plan-mobile';
import { MOBILE_PLAN_PROPTYPES } from '../plan-mobile/constants';

const CompactPlans = ({
  isLoading = false,
  plans,
  collapseHiddenText = '',
  collapseOpenText = '',
  withExtraPrice = false,
}) => (
  <div className="ws-ui-compact-plans">
    {plans.map((item) => (
      <PlanMobile
        {...item}
        key={item.type + item.captions.name}
        collapseHiddenText={collapseHiddenText}
        collapseOpenText={collapseOpenText}
        isLoading={isLoading}
        withExtraPrice={withExtraPrice}
      />
    ))}
  </div>
);

CompactPlans.propTypes = {
  isLoading: PropTypes.bool,
  withExtraPrice: PropTypes.bool,
  plans: PropTypes.arrayOf(PropTypes.shape(MOBILE_PLAN_PROPTYPES)).isRequired,
  collapseHiddenText: PropTypes.string,
  collapseOpenText: PropTypes.string,
};

export default CompactPlans;
